import { Routes, Navigate, Route } from 'react-router-dom';
import { isLoggedIn } from './utils/auth';
import { usePageViews, useClientID } from './utils/analyticsHooks';
import ExternalRedirect from './utils/ExternalRedirect';
import EnterRoutes from './routes/Enter';
import ProfileRoutes from './routes/Profile';
import RedirectRoutes from './routes/h';
import PaymentRoutes from './routes/Payment';
import SubscriptionConfirmedRoute from './routes/Email/SubscriptionConfirmed';
import DiiaSuccessRoute from './routes/DiiaSuccessRoute';
import ChangeEmailRoutes from './routes/change-email';
import AuthWrapper from './routes/common/AuthWrapper';

const App = () => {
  useClientID();
  usePageViews();

  return (
    <Routes>
      <Route path="/enter/*" element={<EnterRoutes />} />

      <Route path="/profile/*" element={<ProfileRoutes />} />

      <Route path="/h/*" element={<RedirectRoutes />} />

      <Route path="/payment/*" element={<PaymentRoutes />} />

      <Route path="/change-email/*" element={<ChangeEmailRoutes />} />

      <Route path="/promo/*" element={<ExternalRedirect to="https://clearvpn.com/redeem/" />} />

      <Route path="/email/subscription-confirmed" element={<SubscriptionConfirmedRoute />} />

      <Route path="/diia/success" element={<DiiaSuccessRoute />} />

      <Route
        path="/account-termination"
        element={
          <AuthWrapper>
            <Navigate to="/profile" />
          </AuthWrapper>
        }
      />

      <Route path="*" element={<Navigate replace to={isLoggedIn() ? '/profile' : '/enter'} />} />
    </Routes>
  );
};

export default App;
